module.exports = __webpack_public_path__ + "static/super-sunday-5035cc59927a988e27359dfcfcef9229.jpg";